import { render, staticRenderFns } from "./RenewPasswordPage.vue?vue&type=template&id=38ce547a&"
import script from "./RenewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RenewPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports